/**
 * Lokale Uhrzeit als `YYYY-MM-DD HH:MM:SS` (dieselbe Form wie dateTimeCreate).
 * Kalenderdatum und Uhrzeit kommen beide von der Geräteuhr. `toISOString()`
 * würde nur das UTC-Datum liefern und den Tag um Mitternacht verschieben.
 * @param {Date} [date]
 * @returns {string}
 */
export function formatLocalProtocolDateTime(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const time = date.toTimeString().split(' ')[0];
    return `${year}-${month}-${day} ${time}`;
}
